import React from "react";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import FameWallNaati from "../components/Frontend/FameWallNaati";
import { Link } from "react-router-dom";
import VideoTestimonial from "../components/Frontend/VideoNaatiTestimonial";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import Slider from "react-slick";
class Naati extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
    };
  }
  handleClick = () => {
    this.setState((prevState) => ({
      isActive: !prevState.isActive,
    }));
  };

  componentDidMount() {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    ReactPixel.init("2474090032742391");
    ReactPixel.init("197333187452630");
    ReactPixel.pageView();
  }
  render() {
    const CardsSlider = {
      dots: true,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      adaptiveHeight: true,
      autoplaySpeed: 5000,
    };
    return (
      <React.Fragment>
        <Helmet>
          <title>NAATI Coaching Classes in Parramatta | Language Academy</title>
          <meta
            name="twitter:title"
            content="Best NAATI CCL Coaching Classes In Parramatta | Top NAATI CCL Training Institute In Sydney"
          />
          <meta
            property="og:title"
            content="Best PTE CCL Coaching Classes In Parramatta | Top NAATI CCL Training Institute In Sydney"
          />

          <meta
            name="description"
            content="Join Language Academy's NAATI coaching classes in Parramatta. Achieve certification with expert training and comprehensive study materials."
          />

          <meta
            name="twitter:description"
            content="Are you searching for the best NAATI coaching classes in Parramatta that can help you achieve sure-shot success in your exam? Language Academy, the top NAATI training institute in Sydney, provides both in-class and online coaching to help the students to improve their scores in the Pearson Test Of English. To get demo classes from the leading NAATI Coaching centre, contact at +61 426230061."
          />
          <meta
            property="og:description"
            content="Are you searching for the best NAATI coaching classes in Parramatta that can help you achieve sure-shot success in your exam? Language Academy, the top NAATI training institute in Sydney, provides both in-class and online coaching to help the students to improve their scores in the Pearson Test Of English. To get demo classes from the leading NAATI Coaching centre, contact at +61 426230061."
          />
        </Helmet>
        <Header />
        <div className="innerPage">
          <div className="banner-section noc-banner">
            <div className="container">
              <div className="row">
                <div className="banner-content">
                  <h1 className="primary-heading dark-blue-color">
                    <span className="fw-700">
                      SECURE YOUR AUSTRALIAN FUTURE
                    </span>{" "}
                    <br className="d-none d-md-block" /> PARRAMATTA'S PREMIER{" "}
                    <span className="wpl-badge pte-naati-badge text-white">
                      Naati ccl
                    </span>{" "}
                    <br /> TRAINING CENTRE
                  </h1>
                  <p className="sub-title">
                    Where expert instruction meets proven success,
                    <br />
                    your pathway to permanent residency starts here.
                  </p>
                  <div className="iframe-video-outer position-relative">
                    {/* <div className="iframe-video-wrapper">
                        <iframe
                        className="iframe-video"
                        src="https://www.youtube.com/embed/6tJN984IoQ4?si=rlOsVJWragJc0zie"
                        title="YouTube video player"
                        frameBorder="0"
                        allowFullScreen
                        ></iframe>
                      </div> */}
                    <div className="banner-img-wrapper">
                      <img
                        className="banner-img"
                        src="/images/web-new-images/banners/naati-banner.png"
                        alt="LA"
                      />
                    </div>
                    <img
                      className="emoji1 position-absolute"
                      src="/images/web-new-images/emojis/emoji-4.png"
                      alt="LA"
                    />
                    <img
                      className="emoji2 position-absolute"
                      src="/images/web-new-images/emojis/emoji-2.png"
                      alt="LA"
                    />
                    <img
                      className="emoji3 position-absolute"
                      src="/images/web-new-images/emojis/emoji-3.png"
                      alt="LA"
                    />
                    <img
                      className="emoji4 position-absolute"
                      src="/images/web-new-images/emojis/emoji-1.png"
                      alt="LA"
                    />
                  </div>
                  <div className="light-blue-box">
                    Achieve your dream of passing the NAATI CCL exam with our
                    expertly tailored training at Parramatta's premier NAATI CCL
                    preparation centre.
                    <br />
                    <br />
                    Build confidence in your language interpretation skills,
                    secure five bonus points for your Australian PR application,
                    and excel with our comprehensive training program designed
                    for aspirants, students, and immigrants.
                  </div>
                  <button
                    className="primary-btn mt-2 border-0"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                  >
                    ENROLL IN OUR PROGRAM TODAY{" "}
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="noc-ccl-exam naati-ccl-exam">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="primary-heading text-center fw-700">
                    <span className="wpl-badge text-white">
                      WHAT IS THE NAATI CCL EXAM?
                    </span>
                    <br className="d-block" />
                    YOUR KEY TO AUSTRALIAN <br className="d-block" /> PERMANENT
                    RESIDENCY
                  </h2>
                </div>
                <div className="col-md-6">
                  <div className="ccl-exam-img">
                    <img
                      src="/images/web-new-images/naati-img.png"
                      alt="Register Now"
                    />
                  </div>
                  <p>
                    The NAATI Credentialled Community Language (CCL) exam is a
                    critical test that evaluates your ability to interpret and
                    translate between English and your chosen language. Passing
                    this test can earn you an extra five points toward your
                    Australian Permanent Residency (PR).
                    <br />
                    <br />
                    The exam consists of two dialogue recordings, each
                    presenting a conversation between an English speaker and a
                    speaker in your specific language. Your task is to interpret
                    and translate accurately while demonstrating confidence and
                    cultural understanding.
                  </p>
                  <div className="text-center text-md-start mb-4 mb-md-0">
                    <a className="primary-btn" target="_blank" href="https://www.laccl.languageacademy.com.au/auth/register">
                      <span className="btn-inner">
                        START YOUR NAATI CCL PREP JOURNEY NOW
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="Register Now"
                        />
                      </span>
                    </a>
                    {/* <Link className="primary-btn" to="/auth/register">
                      <span className="btn-inner">
                        START YOUR NAATI CCL PREP JOURNEY NOW
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="Register Now"
                        />
                      </span>
                    </Link> */}
                  </div>
                </div>
                <div className="col-md-6">
                  <h2 className="content-title">NAATI CCL Test Pattern</h2>
                  <p>
                    The NAATI CCL test assesses your language skills at a
                    community level through recorded conversation dialogues:
                  </p>
                  <ul className="circle-list">
                    <li>
                      <strong>Two recordings</strong> with dialogues of 300
                      words each
                    </li>
                    <li>
                      <strong>30 minutes</strong> total time to complete both
                      recordings
                    </li>
                    <li>
                      <strong>Segments of 35 words</strong> each carrying 45
                      marks
                    </li>
                    <li>
                      <strong>Minimum score of 29</strong> required in each
                      dialogue to pass successfully
                    </li>
                    <li>
                      <strong>Available in 10 languages</strong> Hindi, Punjabi,
                      Urdu, Nepali, Bangla, Tamil, Telugu, Malayalam, Gujarati,
                      and Sinhalese
                    </li>
                  </ul>
                  <div className="light-blue-box">
                    By combining the right resources, expert coaching, and
                    regular practice, you'll not only ace the test but also gain
                    essential skills in bilingual communication. Don't let fear
                    or inexperience hold you back.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="noc-ccl-exam naati-ccl-exam naati-ccl-exam1">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="primary-heading text-center fw-700">
                    <span className="wpl-badge text-white">
                      WHAT IS THE NAATI CCL EXAM?
                    </span>
                    <br className="d-block" />
                    YOUR GATEWAY TO AUSTRALIAN <br className="d-block" />{" "}
                    PERMANENT RESIDENCY
                  </h2>
                </div>
                <div className="col-md-6">
                  <div className="ccl-exam-img">
                    <img
                      src="/images/web-new-images/naati-img-01.png"
                      alt="Register Now"
                    />
                  </div>
                  <p>
                    The NAATI Credentialed Community Language (CCL) exam is an
                    essential test designed to assess your ability to translate
                    and interpret between English and your preferred native
                    language.
                    <br />
                    <br />
                    Since its introduction in July 2018, NAATI CCL has rapidly
                    gained prominence among aspirants seeking permanent
                    residency in Australia.
                    <br />
                    <br />
                    This exam assesses candidates' performance based on their
                    ability to comprehend and translate English dialogues to
                    their chosen LOTE (Language Other Than English) and vice
                    versa. By succeeding in the NAATI CCL exam, you can claim
                    five bonus points on your point-based visa application.
                  </p>
                </div>
                <div className="col-md-6">
                  <h2 className="content-title">NAATI CCL Test Pattern</h2>
                  <p>
                    The NAATI CCL test assesses your language skills at a
                    community level through recorded conversation dialogues:
                  </p>
                  <ul className="circle-list">
                    <li>
                      <strong>Two recorded</strong> dialogues of 300 words each
                    </li>
                    <li>
                      <strong>30 minutes</strong> to complete the test
                    </li>
                    <li>
                      <strong>Each segment contains 35 words,</strong> carrying
                      up to 45 marks
                    </li>
                    <li>
                      <strong>A minimum score of 29 marks</strong> per dialogue
                      is required to pass
                    </li>
                    <li>
                      <strong>Offered in 9 languages</strong> Hindi, Punjabi,
                      Urdu, Nepali, Bangla, Tamil, Telugu, Malayalam, and
                      Gujarati
                    </li>
                  </ul>
                  <div className="light-blue-box">
                    With expert coaching, a tailored study plan, and regular
                    practice, you can not only pass the exam but also build
                    critical bilingual communication skills for your future.
                  </div>
                  <br />
                  <div className="text-center text-md-start mb-4 mb-md-0">
                    <a className="primary-btn" target="_blank" href="https://www.laccl.languageacademy.com.au/auth/register">
                      <span className="btn-inner">
                        START YOUR NAATI CCL PREP JOURNEY NOW{" "}
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="Register Now"
                        />
                      </span>
                    </a>
                    {/* <Link className="primary-btn" to="/auth/register">
                      <span className="btn-inner">
                        START YOUR NAATI CCL PREP JOURNEY NOW{" "}
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="Register Now"
                        />
                      </span>
                    </Link> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="feature-section poc-feature-section noc-feature p-0">
            <div className="container">
              <div className="row">
                <h2 className="primary-heading text-center mb-md-0 fw-700">
                  WHY CHOOSE{" "}
                  <span className="wpl-badge gold-badge text-white">
                    OUR NAATI CCL
                  </span>
                  <br /> TRAINING CENTRE IN PARRAMATTA?
                </h2>
                <p className="sub-title text-center">
                  <br />
                  Are you searching for the top NAATI CCL training center <br />{" "}
                  in Parramatta that can help you accomplish your dreams?
                </p>

                <div className="container">
                  <br />
                  <br />
                  <div className="row">
                    <div className="col-md-6">
                      <p className="light-blue-box">
                        You're in the right place! Do you want to grab these
                        five CCL points for Australia PR, but are confused about
                        how to optimize your NAATI exam preparation?
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p className="light-blue-box">
                        With a proper strategy, by following the right NAATI
                        test preparation course, and practicing regularly, you
                        can take your exam performance to peak level.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="position-relative">
                  <h4 className="sub-sub-title">
                    At Language Academy, Parramatta's trusted
                    <br />
                    NAATI CCL preparation center, we provide
                  </h4>
                  <div className="feature-cards light-feature-cards card-45 d-none d-md-grid">
                    <div className="feature-card mint-green-card">
                      <div className="img-wrapper">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.5 12.0391L10.5 15.0391L16.5 9.03906M22 12.0391C22 17.5619 17.5228 22.0391 12 22.0391C6.47715 22.0391 2 17.5619 2 12.0391C2 6.51621 6.47715 2.03906 12 2.03906C17.5228 2.03906 22 6.51621 22 12.0391Z"
                            stroke="#94C23C"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <h3>
                        Learn From <br /> Certified Trainers
                      </h3>
                      <p>
                        Get insights and strategies from NAATI-accredited
                        professionals who specialize in NAATI standards.
                      </p>
                    </div>
                    <div className="feature-card blue-card">
                      <div className="img-wrapper">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.5 12.0391L10.5 15.0391L16.5 9.03906M22 12.0391C22 17.5619 17.5228 22.0391 12 22.0391C6.47715 22.0391 2 17.5619 2 12.0391C2 6.51621 6.47715 2.03906 12 2.03906C17.5228 2.03906 22 6.51621 22 12.0391Z"
                            stroke="#0286FF"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <h3>
                        Personalized <br /> Feedback
                      </h3>
                      <p>
                        Identify your weaknesses and improve your performance
                        with expert guidance.
                      </p>
                    </div>
                    <div className="feature-card greenish-yellow-card">
                      <div className="img-wrapper">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.5 12.0391L10.5 15.0391L16.5 9.03906M22 12.0391C22 17.5619 17.5228 22.0391 12 22.0391C6.47715 22.0391 2 17.5619 2 12.0391C2 6.51621 6.47715 2.03906 12 2.03906C17.5228 2.03906 22 6.51621 22 12.0391Z"
                            stroke="#48A75C"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <h3>
                        Flexible <br /> Learning Options
                      </h3>
                      <p>
                        Flexible Learning Options Choose between our intensive
                        in-person classes in Parramatta or online training.
                      </p>
                    </div>
                    <div className="feature-card purple-card">
                      <div className="img-wrapper">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.5 12.0391L10.5 15.0391L16.5 9.03906M22 12.0391C22 17.5619 17.5228 22.0391 12 22.0391C6.47715 22.0391 2 17.5619 2 12.0391C2 6.51621 6.47715 2.03906 12 2.03906C17.5228 2.03906 22 6.51621 22 12.0391Z"
                            stroke="#7F56D9"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <h3>Comprehensive Resources</h3>
                      <p>
                        Access up-to-date vocabulary lists, dialogue <br />{" "}
                        exercises, and mock tests.
                      </p>
                    </div>
                    <div className="feature-card light-apricot-card">
                      <div className="img-wrapper">
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.5 11.0391L9.5 14.0391L15.5 8.03906M21 11.0391C21 16.5619 16.5228 21.0391 11 21.0391C5.47715 21.0391 1 16.5619 1 11.0391C1 5.51621 5.47715 1.03906 11 1.03906C16.5228 1.03906 21 5.51621 21 11.0391Z"
                            stroke="#FFB02C"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <h3>Proven Track Record</h3>
                      <p>
                        Join thousands of successful students who have earned
                        their Australian PR points with our support.
                      </p>
                    </div>
                  </div>
                  <div className="slider-dot-arrow d-block d-md-none mobile-slider">
                    <Slider
                      {...CardsSlider}
                      className="feature-cards light-feature-cards"
                    >
                      <div className="feature-card mint-green-card">
                        <div className="img-wrapper">
                          <svg
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.5 12.0391L10.5 15.0391L16.5 9.03906M22 12.0391C22 17.5619 17.5228 22.0391 12 22.0391C6.47715 22.0391 2 17.5619 2 12.0391C2 6.51621 6.47715 2.03906 12 2.03906C17.5228 2.03906 22 6.51621 22 12.0391Z"
                              stroke="#94C23C"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <h3>
                          Learn From <br /> Certified Trainers
                        </h3>
                        <p>
                          Get insights and strategies from NAATI-accredited
                          professionals who specialize in NAATI standards.
                        </p>
                      </div>
                      <div className="feature-card blue-card">
                        <div className="img-wrapper">
                          <svg
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.5 12.0391L10.5 15.0391L16.5 9.03906M22 12.0391C22 17.5619 17.5228 22.0391 12 22.0391C6.47715 22.0391 2 17.5619 2 12.0391C2 6.51621 6.47715 2.03906 12 2.03906C17.5228 2.03906 22 6.51621 22 12.0391Z"
                              stroke="#0286FF"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <h3>
                          Personalized <br /> Feedback
                        </h3>
                        <p>
                          Identify your weaknesses and improve your performance
                          with expert guidance.
                        </p>
                      </div>
                      <div className="feature-card greenish-yellow-card">
                        <div className="img-wrapper">
                          <svg
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.5 12.0391L10.5 15.0391L16.5 9.03906M22 12.0391C22 17.5619 17.5228 22.0391 12 22.0391C6.47715 22.0391 2 17.5619 2 12.0391C2 6.51621 6.47715 2.03906 12 2.03906C17.5228 2.03906 22 6.51621 22 12.0391Z"
                              stroke="#48A75C"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <h3>
                          Flexible <br /> Learning Options
                        </h3>
                        <p>
                          Flexible Learning Options Choose between our intensive
                          in-person classes in Parramatta or online training.
                        </p>
                      </div>
                      <div className="feature-card purple-card">
                        <div className="img-wrapper">
                          <svg
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.5 12.0391L10.5 15.0391L16.5 9.03906M22 12.0391C22 17.5619 17.5228 22.0391 12 22.0391C6.47715 22.0391 2 17.5619 2 12.0391C2 6.51621 6.47715 2.03906 12 2.03906C17.5228 2.03906 22 6.51621 22 12.0391Z"
                              stroke="#7F56D9"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <h3>Comprehensive Resources</h3>
                        <p>
                          Access up-to-date vocabulary lists, dialogue <br />{" "}
                          exercises, and mock tests.
                        </p>
                      </div>
                      <div className="feature-card light-apricot-card">
                        <div className="img-wrapper">
                          <svg
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.5 11.0391L9.5 14.0391L15.5 8.03906M21 11.0391C21 16.5619 16.5228 21.0391 11 21.0391C5.47715 21.0391 1 16.5619 1 11.0391C1 5.51621 5.47715 1.03906 11 1.03906C16.5228 1.03906 21 5.51621 21 11.0391Z"
                              stroke="#FFB02C"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <h3>Proven Track Record</h3>
                        <p>
                          Join thousands of successful students who have earned
                          their Australian PR points with our support.
                        </p>
                      </div>
                    </Slider>
                  </div>
                </div>
                <div className="text-center">
                  <a target="_blank" href="https://www.laccl.languageacademy.com.au/auth/register" className="primary-btn dark-border">
                    ENROLL FOR CCL TRAINING IN PARRAMATTA TODAY
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </a>
                  {/* <Link to="/auth/register" className="primary-btn dark-border">
                    ENROLL FOR CCL TRAINING IN PARRAMATTA TODAY
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </Link> */}
                </div>
              </div>
            </div>
          </div>

          <div className="noc-ccl-exam naati-ccl-exam naati-training-program">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="primary-heading text-center fw-700">
                    Our{" "}
                    <span className="wpl-badge pte-naati-badge text-white">
                      NAATI CCL{" "}
                    </span>{" "}
                    training
                    <br className="d-block" />
                    PROGRAM IN PARRAMATTA
                  </h2>
                </div>
                <div className="col-md-12">
                  <div className="naati-program-header">
                    <div className="left-side">
                      <svg
                        width="50"
                        height="50"
                        viewBox="0 0 64 65"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          y="0.983398"
                          width="64"
                          height="64"
                          rx="32"
                          fill="#0286FF"
                          fillOpacity="0.12"
                        />
                        <path
                          d="M22 32.9834H42M22 32.9834C22 38.5062 26.4772 42.9834 32 42.9834M22 32.9834C22 27.4606 26.4772 22.9834 32 22.9834M42 32.9834C42 38.5062 37.5228 42.9834 32 42.9834M42 32.9834C42 27.4606 37.5228 22.9834 32 22.9834M32 22.9834C34.5013 25.7218 35.9228 29.2754 36 32.9834C35.9228 36.6914 34.5013 40.245 32 42.9834M32 22.9834C29.4987 25.7218 28.0772 29.2754 28 32.9834C28.0772 36.6914 29.4987 40.245 32 42.9834"
                          stroke="#0286FF"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <h2>
                        ONLINE <br /> INTENSIVE COURSE
                      </h2>
                    </div>
                    <div className="right-side">
                      <ul className="circle-list">
                        <li>Up to 4 classes per week</li>
                        <li>In-person training at our Parramatta centre</li>
                        <li>Comprehensive face-to-face instruction</li>
                        <li>Small class sizes for personalized attention</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="ccl-exam-img">
                    <img
                      src="/images/web-new-images/naati-img-02.png"
                      alt="Register Now"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <h2 className="content-title">
                    This program is designed to address common challenges NAATI
                    CCL aspirants face
                  </h2>
                  <ul className="circle-list">
                    <li>Limited access to reliable preparation materials</li>
                    <li>Busy schedules preventing consistent study</li>
                    <li>Lack of practice opportunities</li>
                    <li>Fear of failing the exam and missing out on PR</li>
                  </ul>
                  <div className="text-center text-md-start mb-4 mb-md-0">
                    <Link className="primary-btn" to="/contact">
                      <span className="btn-inner">
                        CHOOSE YOUR PREFERRED TRAINING FORMAT
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="Register Now"
                        />
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="why-choosing-section poc-why-choosing">
            <div className="container">
              <div className="row">
                <h2 className="primary-heading text-center">
                  WHAT WE OFFER AT <br />
                  <span className="wpl-badge text-white">
                    PARRAMATTA TRAINING CENTRE
                  </span>
                </h2>
                <p className="sub-heading text-center">
                  Our comprehensive NAATI CCL preparation program includes
                </p>
                <div className="feature-cards four-cards d-none d-md-grid">
                  <div className="feature-card card2">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 21.8232L11.8999 21.6732C11.2053 20.6312 10.858 20.1102 10.3991 19.7331C9.99286 19.3992 9.52476 19.1487 9.02161 18.9958C8.45325 18.8232 7.82711 18.8232 6.57482 18.8232H5.2C4.07989 18.8232 3.51984 18.8232 3.09202 18.6053C2.71569 18.4135 2.40973 18.1075 2.21799 17.7312C2 17.3034 2 16.7433 2 15.6232V7.02324C2 5.90314 2 5.34308 2.21799 4.91526C2.40973 4.53894 2.71569 4.23298 3.09202 4.04123C3.51984 3.82324 4.07989 3.82324 5.2 3.82324H5.6C7.84021 3.82324 8.96031 3.82324 9.81596 4.25922C10.5686 4.64271 11.1805 5.25463 11.564 6.00728C12 6.86293 12 7.98303 12 10.2232M12 21.8232V10.2232M12 21.8232L12.1001 21.6732C12.7947 20.6312 13.142 20.1102 13.6009 19.7331C14.0071 19.3992 14.4752 19.1487 14.9784 18.9958C15.5467 18.8232 16.1729 18.8232 17.4252 18.8232H18.8C19.9201 18.8232 20.4802 18.8232 20.908 18.6053C21.2843 18.4135 21.5903 18.1075 21.782 17.7312C22 17.3034 22 16.7433 22 15.6232V7.02324C22 5.90314 22 5.34308 21.782 4.91526C21.5903 4.53894 21.2843 4.23298 20.908 4.04123C20.4802 3.82324 19.9201 3.82324 18.8 3.82324H18.4C16.1598 3.82324 15.0397 3.82324 14.184 4.25922C13.4314 4.64271 12.8195 5.25463 12.436 6.00728C12 6.86293 12 7.98303 12 10.2232"
                            stroke="#94C23C"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <h3>INTENSIVE VOCABULARY BUILDING</h3>
                    <ul className="circle-list green">
                      <li>Comprehensive word lists for each language</li>
                      <li>Context-based vocabulary exercises</li>
                      <li>
                        Cultural nuances and terminology specific to NAATI CCL
                      </li>
                    </ul>
                  </div>
                  <div className="feature-card card1">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20 21.8232C20 20.4277 20 19.7299 19.8278 19.1621C19.44 17.8837 18.4395 16.8833 17.1611 16.4955C16.5933 16.3232 15.8956 16.3232 14.5 16.3232H9.5C8.10444 16.3232 7.40665 16.3232 6.83886 16.4955C5.56045 16.8833 4.56004 17.8837 4.17224 19.1621C4 19.7299 4 20.4277 4 21.8232M16.5 8.32324C16.5 10.8085 14.4853 12.8232 12 12.8232C9.51472 12.8232 7.5 10.8085 7.5 8.32324C7.5 5.83796 9.51472 3.82324 12 3.82324C14.4853 3.82324 16.5 5.83796 16.5 8.32324Z"
                            stroke="#7F56D9"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <h3>PERSONAL 1-ON-1 FEEDBACK</h3>
                    <ul className="circle-list">
                      <li>
                        Individual assessment of your interpretation skills
                      </li>
                      <li>Customized improvement strategies</li>
                      <li>Direct interaction with certified trainers</li>
                    </ul>
                  </div>
                  <div className="feature-card card4">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21 18.8232V12.8232C21 7.85268 16.9706 3.82324 12 3.82324C7.02944 3.82324 3 7.85268 3 12.8232V18.8232M5.5 21.8232C4.11929 21.8232 3 20.704 3 19.3232V17.3232C3 15.9425 4.11929 14.8232 5.5 14.8232C6.88071 14.8232 8 15.9425 8 17.3232V19.3232C8 20.704 6.88071 21.8232 5.5 21.8232ZM18.5 21.8232C17.1193 21.8232 16 20.704 16 19.3232V17.3232C16 15.9425 17.1193 14.8232 18.5 14.8232C19.8807 14.8232 21 15.9425 21 17.3232V19.3232C21 20.704 19.8807 21.8232 18.5 21.8232Z"
                            stroke="#FFB02C"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <h3>ONLINE AUDIO DIALOGUES</h3>
                    <ul className="circle-list orange">
                      <li>Extensive library of practice recordings</li>
                      <li>Varied accents and speaking speeds</li>
                      <li>Real exam-style dialogue formats</li>
                    </ul>
                  </div>
                  <div className="feature-card card3">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14 3.09277V7.22331C14 7.78337 14 8.06339 14.109 8.2773C14.2049 8.46547 14.3578 8.61845 14.546 8.71432C14.7599 8.82331 15.0399 8.82331 15.6 8.82331H19.7305M14 17.8232H8M16 13.8232H8M20 10.8115V18.0232C20 19.7034 20 20.5435 19.673 21.1852C19.3854 21.7497 18.9265 22.2086 18.362 22.4963C17.7202 22.8232 16.8802 22.8232 15.2 22.8232H8.8C7.11984 22.8232 6.27976 22.8232 5.63803 22.4963C5.07354 22.2086 4.6146 21.7497 4.32698 21.1852C4 20.5435 4 19.7034 4 18.0232V7.62324C4 5.94308 4 5.10301 4.32698 4.46127C4.6146 3.89678 5.07354 3.43784 5.63803 3.15022C6.27976 2.82324 7.11984 2.82324 8.8 2.82324H12.0118C12.7455 2.82324 13.1124 2.82324 13.4577 2.90613C13.7638 2.97962 14.0564 3.10084 14.3249 3.26532C14.6276 3.45085 14.887 3.71027 15.4059 4.22913L18.5941 7.41735C19.113 7.93621 19.3724 8.19564 19.5579 8.49839C19.7224 8.7668 19.8436 9.05944 19.9171 9.36555C20 9.71081 20 10.0777 20 10.8115Z"
                            stroke="#0286FF"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <h3>REGULAR MOCK EXAMS UNDER EXAM CONDITIONS</h3>
                    <ul className="circle-list blue">
                      <li>
                        Simulated test environment at our Parramatta center
                      </li>
                      <li>Timed practice sessions</li>
                      <li>Detailed performance analysis and feedback</li>
                    </ul>
                  </div>
                </div>

                {/* Mobile HTML */}
                <div className="slider-dot-arrow d-block d-md-none mobile-slider">
                  <Slider {...CardsSlider} className="feature-cards four-cards">
                    <div className="feature-card card2">
                      <div className="rounded-circle">
                        <div className="img-wrapper">
                          <svg
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 21.8232L11.8999 21.6732C11.2053 20.6312 10.858 20.1102 10.3991 19.7331C9.99286 19.3992 9.52476 19.1487 9.02161 18.9958C8.45325 18.8232 7.82711 18.8232 6.57482 18.8232H5.2C4.07989 18.8232 3.51984 18.8232 3.09202 18.6053C2.71569 18.4135 2.40973 18.1075 2.21799 17.7312C2 17.3034 2 16.7433 2 15.6232V7.02324C2 5.90314 2 5.34308 2.21799 4.91526C2.40973 4.53894 2.71569 4.23298 3.09202 4.04123C3.51984 3.82324 4.07989 3.82324 5.2 3.82324H5.6C7.84021 3.82324 8.96031 3.82324 9.81596 4.25922C10.5686 4.64271 11.1805 5.25463 11.564 6.00728C12 6.86293 12 7.98303 12 10.2232M12 21.8232V10.2232M12 21.8232L12.1001 21.6732C12.7947 20.6312 13.142 20.1102 13.6009 19.7331C14.0071 19.3992 14.4752 19.1487 14.9784 18.9958C15.5467 18.8232 16.1729 18.8232 17.4252 18.8232H18.8C19.9201 18.8232 20.4802 18.8232 20.908 18.6053C21.2843 18.4135 21.5903 18.1075 21.782 17.7312C22 17.3034 22 16.7433 22 15.6232V7.02324C22 5.90314 22 5.34308 21.782 4.91526C21.5903 4.53894 21.2843 4.23298 20.908 4.04123C20.4802 3.82324 19.9201 3.82324 18.8 3.82324H18.4C16.1598 3.82324 15.0397 3.82324 14.184 4.25922C13.4314 4.64271 12.8195 5.25463 12.436 6.00728C12 6.86293 12 7.98303 12 10.2232"
                              stroke="#94C23C"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                      <h3>INTENSIVE VOCABULARY BUILDING</h3>
                      <ul className="circle-list green">
                        <li>Comprehensive word lists for each language</li>
                        <li>Context-based vocabulary exercises</li>
                        <li>
                          Cultural nuances and terminology specific to NAATI CCL
                        </li>
                      </ul>
                    </div>
                    <div className="feature-card card1">
                      <div className="rounded-circle">
                        <div className="img-wrapper">
                          <svg
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M20 21.8232C20 20.4277 20 19.7299 19.8278 19.1621C19.44 17.8837 18.4395 16.8833 17.1611 16.4955C16.5933 16.3232 15.8956 16.3232 14.5 16.3232H9.5C8.10444 16.3232 7.40665 16.3232 6.83886 16.4955C5.56045 16.8833 4.56004 17.8837 4.17224 19.1621C4 19.7299 4 20.4277 4 21.8232M16.5 8.32324C16.5 10.8085 14.4853 12.8232 12 12.8232C9.51472 12.8232 7.5 10.8085 7.5 8.32324C7.5 5.83796 9.51472 3.82324 12 3.82324C14.4853 3.82324 16.5 5.83796 16.5 8.32324Z"
                              stroke="#7F56D9"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                      <h3>PERSONAL 1-ON-1 FEEDBACK</h3>
                      <ul className="circle-list">
                        <li>
                          Individual assessment of your interpretation skills
                        </li>
                        <li>Customized improvement strategies</li>
                        <li>Direct interaction with certified trainers</li>
                      </ul>
                    </div>
                    <div className="feature-card card4">
                      <div className="rounded-circle">
                        <div className="img-wrapper">
                          <svg
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21 18.8232V12.8232C21 7.85268 16.9706 3.82324 12 3.82324C7.02944 3.82324 3 7.85268 3 12.8232V18.8232M5.5 21.8232C4.11929 21.8232 3 20.704 3 19.3232V17.3232C3 15.9425 4.11929 14.8232 5.5 14.8232C6.88071 14.8232 8 15.9425 8 17.3232V19.3232C8 20.704 6.88071 21.8232 5.5 21.8232ZM18.5 21.8232C17.1193 21.8232 16 20.704 16 19.3232V17.3232C16 15.9425 17.1193 14.8232 18.5 14.8232C19.8807 14.8232 21 15.9425 21 17.3232V19.3232C21 20.704 19.8807 21.8232 18.5 21.8232Z"
                              stroke="#FFB02C"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                      <h3>ONLINE AUDIO DIALOGUES</h3>
                      <ul className="circle-list orange">
                        <li>Extensive library of practice recordings</li>
                        <li>Varied accents and speaking speeds</li>
                        <li>Real exam-style dialogue formats</li>
                      </ul>
                    </div>
                    <div className="feature-card card3">
                      <div className="rounded-circle">
                        <div className="img-wrapper">
                          <svg
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14 3.09277V7.22331C14 7.78337 14 8.06339 14.109 8.2773C14.2049 8.46547 14.3578 8.61845 14.546 8.71432C14.7599 8.82331 15.0399 8.82331 15.6 8.82331H19.7305M14 17.8232H8M16 13.8232H8M20 10.8115V18.0232C20 19.7034 20 20.5435 19.673 21.1852C19.3854 21.7497 18.9265 22.2086 18.362 22.4963C17.7202 22.8232 16.8802 22.8232 15.2 22.8232H8.8C7.11984 22.8232 6.27976 22.8232 5.63803 22.4963C5.07354 22.2086 4.6146 21.7497 4.32698 21.1852C4 20.5435 4 19.7034 4 18.0232V7.62324C4 5.94308 4 5.10301 4.32698 4.46127C4.6146 3.89678 5.07354 3.43784 5.63803 3.15022C6.27976 2.82324 7.11984 2.82324 8.8 2.82324H12.0118C12.7455 2.82324 13.1124 2.82324 13.4577 2.90613C13.7638 2.97962 14.0564 3.10084 14.3249 3.26532C14.6276 3.45085 14.887 3.71027 15.4059 4.22913L18.5941 7.41735C19.113 7.93621 19.3724 8.19564 19.5579 8.49839C19.7224 8.7668 19.8436 9.05944 19.9171 9.36555C20 9.71081 20 10.0777 20 10.8115Z"
                              stroke="#0286FF"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                      <h3>REGULAR MOCK EXAMS UNDER EXAM CONDITIONS</h3>
                      <ul className="circle-list blue">
                        <li>
                          Simulated test environment at our Parramatta center
                        </li>
                        <li>Timed practice sessions</li>
                        <li>Detailed performance analysis and feedback</li>
                      </ul>
                    </div>
                  </Slider>
                </div>

                <div className="text-center">
                  <Link to="/contact" className="primary-btn">
                    EXPERIENCE OUR COMPREHENSIVE APPROACH
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="master-aspect-section naati-success">
            <div className="container">
              <div className="row">
                <h2 className="primary-heading text-center">
                  ACHIEVE{" "}
                  <span className="wpl-badge gold-badge text-white">
                    NAATI CCL SUCCESS
                  </span>{" "}
                  <br /> WITH FOCUSED SKILL-BUILDING
                </h2>
                <p className="sub-heading text-center">
                  Excelling in the NAATI CCL exam requires honing translation,{" "}
                  <br /> interpretation, and time management abilities. Here's
                  how we support <br /> your journey at our Parramatta training
                  centre
                </p>
                <h4 className="sub-sub-title text-center text-md-start">
                  Here's how we help you prepare
                </h4>

                <div className="master-cards">
                  <div className="master-card">
                    <div className="img-wrapper">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21 18.71V12.71C21 7.7394 16.9706 3.70996 12 3.70996C7.02944 3.70996 3 7.7394 3 12.71V18.71M5.5 21.71C4.11929 21.71 3 20.5907 3 19.21V17.21C3 15.8292 4.11929 14.71 5.5 14.71C6.88071 14.71 8 15.8292 8 17.21V19.21C8 20.5907 6.88071 21.71 5.5 21.71ZM18.5 21.71C17.1193 21.71 16 20.5907 16 19.21V17.21C16 15.8292 17.1193 14.71 18.5 14.71C19.8807 14.71 21 15.8292 21 17.21V19.21C21 20.5907 19.8807 21.71 18.5 21.71Z"
                          stroke="#7F56D9"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <h2 className="card-title">LISTENING SKILLS</h2>
                    <ul>
                      <li>
                        <h4>
                          <span className="circle"></span> What It Tests
                        </h4>
                        <p>
                          Comprehension of language tones, accents, and cultural
                          subtleties
                        </p>
                      </li>
                      <li>
                        <h4>
                          <span className="circle"></span> Our Method
                        </h4>
                        <p>
                          Audio-based exercises to sharpen your listening and
                          cultural awareness
                        </p>
                      </li>
                    </ul>
                  </div>
                  <div className="master-card card2">
                    <div className="img-wrapper">
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.249 17.71H20.4229M13.249 17.71L11.3359 21.71M13.249 17.71L16.1142 11.719C16.3451 11.2362 16.4606 10.9949 16.6185 10.9186C16.7559 10.8522 16.916 10.8522 17.0534 10.9186C17.2113 10.9949 17.3268 11.2362 17.5576 11.719L20.4229 17.71M20.4229 17.71L22.3359 21.71M2.33594 5.70996H8.33594M8.33594 5.70996H11.8359M8.33594 5.70996V3.70996M11.8359 5.70996H14.3359M11.8359 5.70996C11.3398 8.66725 10.1885 11.3461 8.50149 13.5944M10.3359 14.71C9.72341 14.4348 9.09859 14.052 8.50149 13.5944M8.50149 13.5944C7.14896 12.5577 5.9387 11.1366 5.33594 9.70996M8.50149 13.5944C6.8968 15.7329 4.80737 17.4818 2.33594 18.71"
                          stroke="#94C23C"
                          strokeOpacity="0.98"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <h2 className="card-title">
                      TRANSLATION & <br /> INTERPRETATION
                    </h2>
                    <ul>
                      <li>
                        <h4>
                          <span className="circle"></span> What It Tests
                        </h4>
                        <p>
                          Your ability to accurately and fluently interpret
                          dialogues
                        </p>
                      </li>
                      <li>
                        <h4>
                          <span className="circle"></span> Our Method
                        </h4>
                        <p>
                          Practice with real-world dialogues, vocabulary
                          building, and structured mock tests
                        </p>
                      </li>
                    </ul>
                  </div>
                  <div className="master-card card3">
                    <div className="img-wrapper">
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.6641 6.70996V12.71L16.6641 14.71M22.6641 12.71C22.6641 18.2328 18.1869 22.71 12.6641 22.71C7.14121 22.71 2.66406 18.2328 2.66406 12.71C2.66406 7.18711 7.14121 2.70996 12.6641 2.70996C18.1869 2.70996 22.6641 7.18711 22.6641 12.71Z"
                          stroke="#0286FF"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <h2 className="card-title">TIME MANAGEMENT</h2>
                    <ul>
                      <li>
                        <h4>
                          <span className="circle"></span> What It Tests
                        </h4>
                        <p>Staying calm and accurate under pressure</p>
                      </li>
                      <li>
                        <h4>
                          <span className="circle"></span> Our Approach
                        </h4>
                        <p>
                          Training in efficient time utilization while
                          maintaining focus
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="text-center bottom-btn-wrapper">
                  <p className="sub-heading">
                    Prepare smarter and give your best on exam day with our
                    expert techniques.
                  </p>
                  <a target="_blank" href="https://www.laccl.languageacademy.com.au/auth/register" className="primary-btn">
                    SIGN UP FOR OUR TRAINING NOW
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </a>
                  {/* <Link to="/auth/register" className="primary-btn">
                    SIGN UP FOR OUR TRAINING NOW
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </Link> */}
                </div>
              </div>
            </div>
          </div>

          <div className="pc-why-choose why-most-section naati-why-most">
            <div className="container">
              <div className="row why-most-second-row">
                <div className="col-lg-6 why-most-content">
                  <h2 className="primary-heading fw-700">
                    WHY LANGUAGE ACADEMY IS PARRAMATTA'S RIGHT CHOICE FOR NAATI
                    CCL <span className="wpl-badge  text-white">NAATI CCL</span>
                  </h2>
                  <a className="primary-btn" target="_blank" href="https://www.laccl.languageacademy.com.au/auth/register">
                    <span className="btn-inner">
                      JOIN OUR COMMUNITY OF SUCCESSFUL STUDENTS{" "}
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </span>
                  </a>
                  {/* <Link className="primary-btn" to="/auth/register">
                    <span className="btn-inner">
                      JOIN OUR COMMUNITY OF SUCCESSFUL STUDENTS{" "}
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </span>
                  </Link> */}
                </div>
                <div className="col-lg-6">
                  <div className="why-most-list">
                    <ul>
                      <li className="list1">
                        <span className="list-counting">
                          <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19.9847 6.21673L22.4736 8.70562L27.4514 3.72784M27.4514 14.9278V21.399C27.4514 23.4898 27.4514 24.5353 27.0445 25.3339C26.6866 26.0363 26.1154 26.6075 25.413 26.9654C24.6144 27.3723 23.5689 27.3723 21.4781 27.3723H8.53583C6.44497 27.3723 5.39954 27.3723 4.60094 26.9654C3.89846 26.6075 3.32734 26.0363 2.96941 25.3339C2.5625 24.5353 2.5625 23.4898 2.5625 21.399V8.45673C2.5625 6.36587 2.5625 5.32044 2.96941 4.52183C3.32734 3.81936 3.89846 3.24823 4.60094 2.89031C5.39954 2.4834 6.44497 2.4834 8.53583 2.4834H15.0069M2.74358 24.7917C3.3274 22.6914 5.25369 21.1501 7.53999 21.1501H16.2511C17.4076 21.1501 17.9858 21.1501 18.4667 21.2457C20.4413 21.6385 21.9849 23.1821 22.3777 25.1567C22.4733 25.6376 22.4733 26.2158 22.4733 27.3723M17.4958 11.8167C17.4958 14.5659 15.2672 16.7945 12.5181 16.7945C9.76891 16.7945 7.54028 14.5659 7.54028 11.8167C7.54028 9.06758 9.76891 6.83895 12.5181 6.83895C15.2672 6.83895 17.4958 9.06758 17.4958 11.8167Z"
                              stroke="#7F56D9"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <div>
                          <h3>CERTIFIED TRAINERS</h3>
                          <p>
                            Work with instructors who know the ins and outs of
                            the NAATI CCL exam and have extensive experience in
                            Parramatta.
                          </p>
                        </div>
                      </li>
                      <li className="list2">
                        <span className="list-counting">
                          <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.86398 19.2335L8.78299 27.3723L14.493 23.9463C14.6792 23.8345 14.7723 23.7787 14.8718 23.7568C14.9597 23.7375 15.0507 23.7375 15.1387 23.7568C15.2381 23.7787 15.3312 23.8345 15.5174 23.9463L21.2274 27.3723L20.1472 19.23M20.513 5.282C20.7052 5.74683 21.0741 6.1163 21.5386 6.3092L23.1674 6.98391C23.6323 7.17646 24.0016 7.54579 24.1941 8.01065C24.3867 8.47551 24.3867 8.99783 24.1941 9.46269L23.5199 11.0904C23.3273 11.5555 23.327 12.0783 23.5205 12.5432L24.1936 14.1704C24.289 14.4006 24.3382 14.6474 24.3382 14.8967C24.3383 15.1459 24.2892 15.3927 24.1938 15.623C24.0984 15.8533 23.9586 16.0625 23.7824 16.2387C23.6061 16.4149 23.3968 16.5547 23.1665 16.65L21.5389 17.3242C21.0741 17.5164 20.7046 17.8853 20.5117 18.3499L19.837 19.9788C19.6445 20.4436 19.2752 20.8129 18.8103 21.0055C18.3455 21.198 17.8232 21.198 17.3583 21.0055L15.7307 20.3313C15.2658 20.1392 14.7437 20.1396 14.2791 20.3324L12.6503 21.0061C12.1857 21.1982 11.6639 21.198 11.1994 21.0057C10.735 20.8133 10.3658 20.4444 10.1732 19.98L9.49828 18.3506C9.30609 17.8858 8.93718 17.5163 8.47267 17.3234L6.84383 16.6487C6.37919 16.4562 6.00998 16.0871 5.81737 15.6226C5.62475 15.158 5.62449 14.6359 5.81664 14.1711L6.49084 12.5434C6.68291 12.0785 6.68252 11.5564 6.48975 11.0918L5.81652 9.46173C5.72106 9.23149 5.67191 8.9847 5.67188 8.73546C5.67184 8.48621 5.72091 8.23941 5.81628 8.00914C5.91166 7.77887 6.05148 7.56965 6.22774 7.39343C6.404 7.21722 6.61326 7.07747 6.84355 6.98216L8.47122 6.30793C8.93562 6.1159 9.30486 5.74745 9.49789 5.28345L10.1726 3.65455C10.3651 3.18969 10.7344 2.82036 11.1993 2.62781C11.6641 2.43526 12.1864 2.43526 12.6513 2.62781L14.2789 3.30204C14.7438 3.49412 15.2659 3.49372 15.7305 3.30095L17.36 2.62886C17.8248 2.43641 18.3469 2.43645 18.8117 2.62897C19.2765 2.82148 19.6457 3.1907 19.8383 3.65544L20.5132 5.28483L20.513 5.282Z"
                              stroke="#0286FF"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <div>
                          <h3>EXCEPTIONAL RESULTS</h3>
                          <p>
                            Join over 50,000 students who have successfully
                            passed the exam and earned their PR points through
                            our proven methods.
                          </p>
                        </div>
                      </li>
                      <li className="list3">
                        <span className="list-counting">
                          <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15.0069 26.128L14.8824 25.9413C14.018 24.6446 13.5858 23.9963 13.0147 23.5269C12.5092 23.1114 11.9267 22.7996 11.3005 22.6095C10.5932 22.3947 9.81401 22.3947 8.25561 22.3947H6.54472C5.15081 22.3947 4.45386 22.3947 3.92146 22.1234C3.45314 21.8848 3.07239 21.5041 2.83377 21.0357C2.5625 20.5033 2.5625 19.8064 2.5625 18.4125V7.71025C2.5625 6.31634 2.5625 5.61939 2.83377 5.08698C3.07239 4.61867 3.45314 4.23792 3.92146 3.9993C4.45386 3.72803 5.15081 3.72803 6.54472 3.72803H7.0425C9.83032 3.72803 11.2242 3.72803 12.289 4.27057C13.2257 4.74781 13.9872 5.50931 14.4644 6.44594C15.0069 7.51075 15.0069 8.90466 15.0069 11.6925M15.0069 26.128V11.6925M15.0069 26.128L15.1315 25.9413C15.9959 24.6446 16.4281 23.9963 16.9992 23.5269C17.5047 23.1114 18.0872 22.7996 18.7134 22.6095C19.4207 22.3947 20.1999 22.3947 21.7583 22.3947H23.4692C24.8631 22.3947 25.56 22.3947 26.0924 22.1234C26.5608 21.8848 26.9415 21.5041 27.1801 21.0357C27.4514 20.5033 27.4514 19.8064 27.4514 18.4125V7.71025C27.4514 6.31634 27.4514 5.61939 27.1801 5.08698C26.9415 4.61867 26.5608 4.23792 26.0924 3.9993C25.56 3.72803 24.8631 3.72803 23.4692 3.72803H22.9714C20.1836 3.72803 18.7897 3.72803 17.7249 4.27057C16.7882 4.74781 16.0267 5.50931 15.5495 6.44594C15.0069 7.51075 15.0069 8.90466 15.0069 11.6925"
                              stroke="#94C23C"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <div>
                          <h3>FREE STUDY RESOURCES</h3>
                          <p>
                            Access proven templates, books, and vocabulary lists
                            specifically designed for NAATI CCL success.
                          </p>
                        </div>
                      </li>
                      <li className="list4">
                        <span className="list-counting">
                          <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15.0002 16.1725V8.70581M11.2668 12.4391H18.7335M23.7113 26.128V9.70136C23.7113 7.6105 23.7113 6.56507 23.3044 5.76646C22.9465 5.06399 22.3753 4.49286 21.6729 4.13494C20.8742 3.72803 19.8288 3.72803 17.738 3.72803H12.2624C10.1715 3.72803 9.1261 3.72803 8.3275 4.13494C7.62503 4.49286 7.0539 5.06399 6.69597 5.76646C6.28906 6.56507 6.28906 7.6105 6.28906 9.70136V26.128L15.0002 21.1503L23.7113 26.128Z"
                              stroke="#FFB02C"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <div>
                          <h3>LATEST PREP TOOLS</h3>
                          <p>
                            Study smarter with our cutting-edge mobile app and
                            online platform accessible anytime.
                          </p>
                        </div>
                      </li>
                      <li className="list5">
                        <span className="list-counting">
                          <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M26.2047 22.3947V14.928C26.2047 8.74244 21.1903 3.72803 15.0047 3.72803C8.8191 3.72803 3.80469 8.74244 3.80469 14.928V22.3947M6.9158 26.128C5.19758 26.128 3.80469 24.7351 3.80469 23.0169V20.528C3.80469 18.8098 5.19758 17.4169 6.9158 17.4169C8.63402 17.4169 10.0269 18.8098 10.0269 20.528V23.0169C10.0269 24.7351 8.63402 26.128 6.9158 26.128ZM23.0936 26.128C21.3754 26.128 19.9825 24.7351 19.9825 23.0169V20.528C19.9825 18.8098 21.3754 17.4169 23.0936 17.4169C24.8118 17.4169 26.2047 18.8098 26.2047 20.528V23.0169C26.2047 24.7351 24.8118 26.128 23.0936 26.128Z"
                              stroke="#48A75C"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <div>
                          <h3>24/7 SUPPORT</h3>
                          <p>
                            Receive guidance from our team whenever you need it,
                            whether you're studying at our Parramatta centre or
                            online.
                          </p>
                        </div>
                      </li>
                      <li className="list6">
                        <span className="list-counting">
                          <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.5181 18.6612L8.69107 22.536C8.15726 23.0765 7.89035 23.3467 7.66093 23.3658C7.46189 23.3823 7.26702 23.3023 7.13703 23.1507C6.98719 22.9759 6.98719 22.5961 6.98719 21.8364V19.8952C6.98719 19.2137 6.42908 18.7205 5.75475 18.6218V18.6218C4.12271 18.3827 2.84098 17.101 2.60192 15.4689C2.5625 15.1998 2.5625 14.8787 2.5625 14.2365V8.45673C2.5625 6.36587 2.5625 5.32044 2.96941 4.52183C3.32734 3.81936 3.89846 3.24823 4.60094 2.89031C5.39954 2.4834 6.44497 2.4834 8.53583 2.4834H17.7447C19.8356 2.4834 20.881 2.4834 21.6796 2.89031C22.3821 3.24823 22.9532 3.81936 23.3111 4.52183C23.7181 5.32044 23.7181 6.36587 23.7181 8.45673V13.6834M23.7181 27.3723L21.0096 25.4893C20.6289 25.2246 20.4386 25.0923 20.2314 24.9984C20.0475 24.9151 19.8542 24.8545 19.6557 24.818C19.432 24.7767 19.2001 24.7767 18.7364 24.7767H16.5003C15.1064 24.7767 14.4094 24.7767 13.877 24.5055C13.4087 24.2668 13.0279 23.8861 12.7893 23.4178C12.5181 22.8854 12.5181 22.1884 12.5181 20.7945V17.6656C12.5181 16.2717 12.5181 15.5748 12.7893 15.0424C13.0279 14.574 13.4087 14.1933 13.877 13.9547C14.4094 13.6834 15.1064 13.6834 16.5003 13.6834H23.4692C24.8631 13.6834 25.56 13.6834 26.0924 13.9547C26.5608 14.1933 26.9415 14.574 27.1801 15.0424C27.4514 15.5748 27.4514 16.2717 27.4514 17.6656V21.0434C27.4514 22.2031 27.4514 22.7829 27.2619 23.2403C27.0093 23.8502 26.5248 24.3347 25.915 24.5873C25.4576 24.7767 24.8777 24.7767 23.7181 24.7767V27.3723Z"
                              stroke="#0286FF"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <div>
                          <h3>DISCUSSION SESSIONS</h3>
                          <p>
                            Personalized strategies based on your strengths and
                            weaknesses identified during our assessment
                            sessions.
                          </p>
                        </div>
                      </li>

                      <li className="list7">
                        <span className="list-counting">
                          <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.54028 13.6833V18.6611M22.4736 11.1944V16.1722M21.2292 4.97217C24.2764 4.97217 25.9246 5.43854 26.7447 5.80027C26.8539 5.84845 26.9085 5.87254 27.0661 6.02294C27.1606 6.1131 27.333 6.37764 27.3774 6.50046C27.4514 6.70535 27.4514 6.81736 27.4514 7.04136V20.4171C27.4514 21.5481 27.4514 22.1135 27.2818 22.4042C27.1093 22.6998 26.9429 22.8373 26.62 22.9509C26.3026 23.0626 25.6618 22.9395 24.3803 22.6932C23.4833 22.5209 22.4195 22.3944 21.2292 22.3944C17.4958 22.3944 13.7625 24.8833 8.78472 24.8833C5.73744 24.8833 4.08927 24.4169 3.2692 24.0552C3.15999 24.007 3.10538 23.9829 2.94778 23.8325C2.85331 23.7423 2.68087 23.4778 2.63651 23.355C2.5625 23.1501 2.5625 23.0381 2.5625 22.8141L2.5625 9.4383C2.5625 8.30739 2.5625 7.74193 2.73209 7.45128C2.9046 7.15563 3.07097 7.01818 3.39386 6.90456C3.71129 6.79285 4.35205 6.91597 5.63358 7.1622C6.53056 7.33455 7.59439 7.46106 8.78472 7.46106C12.5181 7.46106 16.2514 4.97217 21.2292 4.97217ZM18.1181 14.9277C18.1181 16.6459 16.7252 18.0388 15.0069 18.0388C13.2887 18.0388 11.8958 16.6459 11.8958 14.9277C11.8958 13.2095 13.2887 11.8166 15.0069 11.8166C16.7252 11.8166 18.1181 13.2095 18.1181 14.9277Z"
                              stroke="#FFB02C"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <div>
                          <h3>AFFORDABILITY</h3>
                          <p>
                            Flexible fee plans designed for every budget, making
                            quality NAATI CCL training accessible to all.
                          </p>
                        </div>
                      </li>
                      <li className="list8">
                        <span className="list-counting">
                          <svg
                            width="28"
                            height="22"
                            viewBox="0 0 28 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M25.2069 15.9055V4.95439C25.2069 3.56048 25.2069 2.86353 24.9357 2.33113C24.6971 1.86281 24.3163 1.48206 23.848 1.24344C23.3156 0.972168 22.6186 0.972168 21.2247 0.972168H6.78917C5.39526 0.972168 4.6983 0.972168 4.1659 1.24344C3.69759 1.48206 3.31684 1.86281 3.07822 2.33113C2.80694 2.86353 2.80694 3.56048 2.80694 4.95439V15.9055M4.88102 20.8833H23.1329C23.9044 20.8833 24.2902 20.8833 24.6067 20.7985C25.4656 20.5683 26.1364 19.8975 26.3666 19.0386C26.4514 18.7221 26.4514 18.3363 26.4514 17.5648C26.4514 17.179 26.4514 16.9861 26.409 16.8279C26.2939 16.3984 25.9585 16.063 25.529 15.9479C25.3708 15.9055 25.1779 15.9055 24.7921 15.9055H3.22176C2.83599 15.9055 2.64311 15.9055 2.48486 15.9479C2.05541 16.063 1.71997 16.3984 1.6049 16.8279C1.5625 16.9861 1.5625 17.179 1.5625 17.5648C1.5625 18.3363 1.5625 18.7221 1.64731 19.0386C1.87745 19.8975 2.54832 20.5683 3.40722 20.7985C3.72372 20.8833 4.10949 20.8833 4.88102 20.8833Z"
                              stroke="#7F56D9"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <div>
                          <h3>EXAM SIMULATION</h3>
                          <p>
                            Mock tests that recreate real exam conditions at our
                            fully-equipped Parramatta training facility.
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="naati-mobile-app">
            <div className="container">
              <div className="row">
                <h2 className="primary-heading text-center fw-700">
                  LANGUAGE ACADEMY MOBILE APP <br /> your{" "}
                  <span className="wpl-badge  text-white">NAATI CCL PREP</span>{" "}
                  ON-THE-GO
                </h2>
                <h2 className="comprehensive-title text-white">
                  <br />
                  Prepare for the NAATI CCL exam on your own terms <br /> with
                  our powerful mobile application
                </h2>
                <div className="third-row blue-card-row d-none d-md-grid">
                  <div className="feature-card card1">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 11.2119H21M1 11.2119C1 16.7348 5.47715 21.2119 11 21.2119M1 11.2119C1 5.68907 5.47715 1.21191 11 1.21191M21 11.2119C21 16.7348 16.5228 21.2119 11 21.2119M21 11.2119C21 5.68907 16.5228 1.21191 11 1.21191M11 1.21191C13.5013 3.95027 14.9228 7.50395 15 11.2119C14.9228 14.9199 13.5013 18.4736 11 21.2119M11 1.21191C8.49872 3.95027 7.07725 7.50395 7 11.2119C7.07725 14.9199 8.49872 18.4736 11 21.2119"
                            stroke="#0286FF"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <h3>VOCABULARY BANK</h3>
                    <p>
                      Access 2000+ words in seven essential categories,
                      available with translations for all supported languages.
                    </p>
                  </div>
                  <div className="feature-card card2">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 6.21191V12.2119L16 14.2119M22 12.2119C22 17.7348 17.5228 22.2119 12 22.2119C6.47715 22.2119 2 17.7348 2 12.2119C2 6.68907 6.47715 2.21191 12 2.21191C17.5228 2.21191 22 6.68907 22 12.2119Z"
                            stroke="#94C23C"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <h3>REALISTIC MOCK TESTS</h3>
                    <p>
                      Practice in an environment that mimics the actual test,
                      whether you're at our Parramatta centre or studying
                      remotely.
                    </p>
                  </div>
                  <div className="feature-card card3">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 17.7119H12.01M8.2 22.2119H15.8C16.9201 22.2119 17.4802 22.2119 17.908 21.9939C18.2843 21.8022 18.5903 21.4962 18.782 21.1199C19 20.6921 19 20.132 19 19.0119V5.41191C19 4.29181 19 3.73176 18.782 3.30393C18.5903 2.92761 18.2843 2.62165 17.908 2.4299C17.4802 2.21191 16.9201 2.21191 15.8 2.21191H8.2C7.0799 2.21191 6.51984 2.21191 6.09202 2.4299C5.71569 2.62165 5.40973 2.92761 5.21799 3.30393C5 3.73176 5 4.29181 5 5.41191V19.0119C5 20.132 5 20.6921 5.21799 21.1199C5.40973 21.4962 5.71569 21.8022 6.09202 21.9939C6.51984 22.2119 7.07989 22.2119 8.2 22.2119ZM12.5 17.7119C12.5 17.9881 12.2761 18.2119 12 18.2119C11.7239 18.2119 11.5 17.9881 11.5 17.7119C11.5 17.4358 11.7239 17.2119 12 17.2119C12.2761 17.2119 12.5 17.4358 12.5 17.7119Z"
                            stroke="#7F56D9"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <h3>PRACTICE DIALOGUES</h3>
                    <p>
                      Learn with 80+ dialogues inspired by previous exams,
                      complete with expert sample answers.
                    </p>
                  </div>
                  <div className="feature-card card4">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 16.2119V21.2119M12 16.2119L18 21.2119M12 16.2119L6 21.2119M8 7.21191V12.2119M12 9.21191V12.2119M16 11.2119V12.2119M22 3.21191H2M3 3.21191H21V11.4119C21 13.0921 21 13.9321 20.673 14.5739C20.3854 15.1384 19.9265 15.5973 19.362 15.8849C18.7202 16.2119 17.8802 16.2119 16.2 16.2119H7.8C6.11984 16.2119 5.27976 16.2119 4.63803 15.8849C4.07354 15.5973 3.6146 15.1384 3.32698 14.5739C3 13.9321 3 13.0921 3 11.4119V3.21191Z"
                            stroke="#FFB02C"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <h3>LAST-MINUTE BOOSTER PACKAGES</h3>
                    <p>
                      Build your confidence with targeted tips and exercises
                      designed for speedy results.
                    </p>
                  </div>
                </div>
                {/* Mobile HTML */}
                <div className="slider-dot-arrow d-block d-md-none mobile-slider">
                  <Slider {...CardsSlider} className="third-row blue-card-row">
                    <div className="feature-card card1">
                      <div className="rounded-circle">
                        <div className="img-wrapper">
                          <svg
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 11.2119H21M1 11.2119C1 16.7348 5.47715 21.2119 11 21.2119M1 11.2119C1 5.68907 5.47715 1.21191 11 1.21191M21 11.2119C21 16.7348 16.5228 21.2119 11 21.2119M21 11.2119C21 5.68907 16.5228 1.21191 11 1.21191M11 1.21191C13.5013 3.95027 14.9228 7.50395 15 11.2119C14.9228 14.9199 13.5013 18.4736 11 21.2119M11 1.21191C8.49872 3.95027 7.07725 7.50395 7 11.2119C7.07725 14.9199 8.49872 18.4736 11 21.2119"
                              stroke="#0286FF"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                      <h3>VOCABULARY BANK</h3>
                      <p>
                        Access 2000+ words in seven essential categories,
                        available with translations for all supported languages.
                      </p>
                    </div>
                    <div className="feature-card card2">
                      <div className="rounded-circle">
                        <div className="img-wrapper">
                          <svg
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 6.21191V12.2119L16 14.2119M22 12.2119C22 17.7348 17.5228 22.2119 12 22.2119C6.47715 22.2119 2 17.7348 2 12.2119C2 6.68907 6.47715 2.21191 12 2.21191C17.5228 2.21191 22 6.68907 22 12.2119Z"
                              stroke="#94C23C"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                      <h3>REALISTIC MOCK TESTS</h3>
                      <p>
                        Practice in an environment that mimics the actual test,
                        whether you're at our Parramatta centre or studying
                        remotely.
                      </p>
                    </div>
                    <div className="feature-card card3">
                      <div className="rounded-circle">
                        <div className="img-wrapper">
                          <svg
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 17.7119H12.01M8.2 22.2119H15.8C16.9201 22.2119 17.4802 22.2119 17.908 21.9939C18.2843 21.8022 18.5903 21.4962 18.782 21.1199C19 20.6921 19 20.132 19 19.0119V5.41191C19 4.29181 19 3.73176 18.782 3.30393C18.5903 2.92761 18.2843 2.62165 17.908 2.4299C17.4802 2.21191 16.9201 2.21191 15.8 2.21191H8.2C7.0799 2.21191 6.51984 2.21191 6.09202 2.4299C5.71569 2.62165 5.40973 2.92761 5.21799 3.30393C5 3.73176 5 4.29181 5 5.41191V19.0119C5 20.132 5 20.6921 5.21799 21.1199C5.40973 21.4962 5.71569 21.8022 6.09202 21.9939C6.51984 22.2119 7.07989 22.2119 8.2 22.2119ZM12.5 17.7119C12.5 17.9881 12.2761 18.2119 12 18.2119C11.7239 18.2119 11.5 17.9881 11.5 17.7119C11.5 17.4358 11.7239 17.2119 12 17.2119C12.2761 17.2119 12.5 17.4358 12.5 17.7119Z"
                              stroke="#7F56D9"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                      <h3>PRACTICE DIALOGUES</h3>
                      <p>
                        Learn with 80+ dialogues inspired by previous exams,
                        complete with expert sample answers.
                      </p>
                    </div>
                    <div className="feature-card card4">
                      <div className="rounded-circle">
                        <div className="img-wrapper">
                          <svg
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 16.2119V21.2119M12 16.2119L18 21.2119M12 16.2119L6 21.2119M8 7.21191V12.2119M12 9.21191V12.2119M16 11.2119V12.2119M22 3.21191H2M3 3.21191H21V11.4119C21 13.0921 21 13.9321 20.673 14.5739C20.3854 15.1384 19.9265 15.5973 19.362 15.8849C18.7202 16.2119 17.8802 16.2119 16.2 16.2119H7.8C6.11984 16.2119 5.27976 16.2119 4.63803 15.8849C4.07354 15.5973 3.6146 15.1384 3.32698 14.5739C3 13.9321 3 13.0921 3 11.4119V3.21191Z"
                              stroke="#FFB02C"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                      <h3>LAST-MINUTE BOOSTER PACKAGES</h3>
                      <p>
                        Build your confidence with targeted tips and exercises
                        designed for speedy results.
                      </p>
                    </div>
                  </Slider>
                </div>
                <h2 className="comprehensive-title text-white">
                  <br />
                  <br />
                  START YOUR ON CAMPUS COACHING PLAN
                </h2>
                <div className="plan-cards">
                  <div className="plan-card-outer">
                    <div className="plan-card">
                    <div className="icon-wrapper">
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.49072L6 12.4907L1 7.49072"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="content-wrapper">
                      <h2>IN-PERSON TRAINING</h2>
                      <p>
                        Attend classes at one of our 12 locations across
                        Australia, India, and Nepal
                      </p>
                    </div>
                  </div>
                  </div>
                  <div className="plan-card-outer">                  
                  <div className="plan-card">
                    <div className="icon-wrapper">
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.49072L6 12.4907L1 7.49072"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="content-wrapper">
                      <h2>ONE-ON-ONE SESSIONS</h2>
                      <p>
                        Personal coaching tailored to your specific challenges
                        and goals
                      </p>
                    </div>
                  </div>
                  </div>
                  <div className="plan-card-outer">
                  <div className="plan-card">
                    <div className="icon-wrapper">
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.49072L6 12.4907L1 7.49072"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="content-wrapper">
                      <h2>INTENSIVE WORKSHOPS</h2>
                      <p>
                        Participate in specialized sessions targeting high-value
                        exam components
                      </p>
                    </div>
                  </div>
                  </div>
                   <div className="plan-card-outer">                   
                  <div className="plan-card">
                    <div className="icon-wrapper">
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.49072L6 12.4907L1 7.49072"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="content-wrapper">
                      <h2>EXTENDED SUPPORT</h2>
                      <p>
                        Continuous guidance until you achieve your required
                        score
                      </p>
                    </div>
                  </div>
                  </div>
                  <div className="plan-card-outer">
                  
                  <div className="plan-card">
                    <div className="icon-wrapper">
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.49072L6 12.4907L1 7.49072"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="content-wrapper">
                      <h2>EXAM BOOKING ASSISTANCE</h2>
                      <p>
                        Help with scheduling and preparing for your test day
                      </p>
                    </div>
                  </div>
                  </div>
                </div>

                <div className="downlaodnow-row">
                  <div className="downlaodnow-content">
                    <h2>NAATI CCL</h2>
                    <p>
                      Download our NA CCL App
                      <br />
                      from App Store and Play Store
                    </p>
                  </div>
                  <div className="downlaodnow-img">
                    <img
                      src="/images/web-new-images/welcome-img.png"
                      alt="Register Now"
                    />
                  </div>
                  <div>
                    <h3 className="downlaodnow-title">Download Now!</h3>
                    <div className="downlaodnow-btns">
                      <a target="_blank" href="https://play.google.com/store/apps/details?id=com.languageacademy.naati" className="downlaod-btn">
                        <img
                          src="/images/web-new-images/google-play-01.svg"
                          alt="Register Now"
                        />
                      </a>
                      <a target="_blank" href="https://apps.apple.com/au/app/la-ccl/id1536541464" className="downlaod-btn">
                        <img
                          src="/images/web-new-images/app-store-01.svg"
                          alt="Register Now"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="faq-section mt-faq">
            <div className="container">
              <div className="row">
                <h2 className="secondary-heading text-center">
                  Frequently Asked Questions
                </h2>
                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        How long does it take to prepare for the NAATI CCL exam?
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Most students need 4-6 weeks of consistent preparation,
                        but with our intensive 8-week course at our Parramatta
                        centre, you'll be fully prepared.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        Do you offer both online and in-person classes?
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum dolor, sit amet consectetur adipisicing
                        elit. Mollitia laborum, vitae sed, nisi earum a,
                        voluptatibus accusamus quibusdam non modi nam fugit.
                        Facere, perspiciatis illum blanditiis eum assumenda nam
                        iusto.
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFour">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        What languages do you offer NAATI CCL preparation for?
                      </button>
                    </h2>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Quidem architecto, qui nobis molestias fuga velit porro
                        veritatis nesciunt non. Minima facilis iusto, ea
                        nesciunt quod ipsum eveniet velit quia reiciendis!
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        How can I book a free demo class at your Parramatta
                        centre?
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Quidem architecto, qui nobis molestias fuga velit porro
                        veritatis nesciunt non. Minima facilis iusto, ea
                        nesciunt quod ipsum eveniet velit quia reiciendis!
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFive">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive"
                        aria-expanded="false"
                        aria-controls="collapseFive"
                      >
                        What makes your Parramatta training centre different?
                      </button>
                    </h2>
                    <div
                      id="collapseFive"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFive"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Quidem architecto, qui nobis molestias fuga velit porro
                        veritatis nesciunt non. Minima facilis iusto, ea
                        nesciunt quod ipsum eveniet velit quia reiciendis!
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingSix">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSix"
                        aria-expanded="false"
                        aria-controls="collapseSix"
                      >
                        When was the NAATI CCL exam introduced?
                      </button>
                    </h2>
                    <div
                      id="collapseSix"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingSix"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Quidem architecto, qui nobis molestias fuga velit porro
                        veritatis nesciunt non. Minima facilis iusto, ea
                        nesciunt quod ipsum eveniet velit quia reiciendis!
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingSeven">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSeven"
                        aria-expanded="false"
                        aria-controls="collapseSeven"
                      >
                        What is included in your training programs?
                      </button>
                    </h2>
                    <div
                      id="collapseSeven"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingSeven"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Quidem architecto, qui nobis molestias fuga velit porro
                        veritatis nesciunt non. Minima facilis iusto, ea
                        nesciunt quod ipsum eveniet velit quia reiciendis!
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

export default Naati;
